module.exports = __webpack_public_path__ + "img/zichan.1b2824d9.png";